import React, { useState, useCallback } from 'react'
import LoginForm from '@/components/LoginForm'
import SurveyQuestions from '@/components/SurveyQuestions'

const Survey = ({
  title,
  video,
  aside,
  webinarmeta,
  webinarid,
  banner,
  sponsors,
  survey,
  backgroundtype = 'dark',
}) => {
  const { description } = video
  const { start, end, about, place, promovideo } = webinarmeta

  const event = {
    id: webinarid,
    startTime: start,
    endTime: end,
    location: place,
    title: title,
    description: description,
  }

  const [showLogin, setShowLogin] = useState(true)
  const [email, setEmail] = useState(false)
  const [showNoEmail, setShowNoEmail] = useState(false)
  const [showQuestions, setShowQuestions] = useState(false)
  const [showEnd, setShowEnd] = useState(false)

  return (
    <div className="mx-auto text-center">
      <div className="bg-white pt-4 px-2 sm:px-16">
        {showEnd ? (
          <div className="p-16">
            <h1 className="leading-none mb-6 text-2xl font-bold sm:text-4xl">
              Gracias por darte el tiempo de contestar
            </h1>
            <div className="mx-auto max-w-screen-sm">
              <p>Queremos seguir mejorando.</p>
            </div>
          </div>
        ) : (
          <div>
            <h1 className="leading-none mb-6 text-2xl font-bold sm:text-4xl">
              ¿Qué te ha parecido el webinar?
            </h1>
            <div className="mx-auto max-w-screen-sm">
              <p>
                Gracias participar en nuestra Ciclos Claro Empresas:{' '}
                <strong>{title}</strong>. Queremos saber qué te ha parecido. A
                continuación unas preguntas que nos ayudarán a mejorar la
                experiencia.
              </p>
              <p>
                Ingresa el correo electrónico con el cual te registraste para el
                webinar
              </p>
              {showLogin && (
                <LoginForm
                  event={event}
                  tag={false}
                  backgroundtype={backgroundtype}
                  onLogged={email => {
                    setEmail(email)
                    setShowLogin(false)
                    setShowQuestions(true)
                  }}
                  onTriggerRegister={email => {
                    setEmail(email)
                    setShowLogin(false)
                    setShowNoEmail(true)
                  }}
                />
              )}
              {showNoEmail && (
                <div>
                  <h3>Lo sentimos</h3>
                  <p>
                    Parece que el correo <strong>{email}</strong> no existe o no
                    te registraste con éste al momento de ver el video.
                  </p>
                  <button
                    className=""
                    onClick={() => {
                      setEmail(false)
                      setShowLogin(true)
                      setShowNoEmail(false)
                    }}>
                    Intenta nuevamente
                  </button>
                </div>
              )}
              {showQuestions && (
                <SurveyQuestions
                  survey={survey}
                  email={email}
                  webinar={webinarid}
                  backgroundtype={backgroundtype}
                  onEnd={() => {
                    setShowEnd(true)
                  }}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default Survey
